import { Avatar, Badge, Box, Group, Image, Paper, Stack, Text } from '@mantine/core';
import classes from './AsideMessage.module.css';
export type AsideFriendMessageProps = {
  isAvatar?: boolean;
  isLevel?: boolean;
  isTag?: boolean;
  tag?: string;
  level?: string;
  username?: string;
  text?: string;
};
export const AsideFriendMessage: React.FC<AsideFriendMessageProps> = ({
  isAvatar,
  isLevel,
  isTag,
  tag,
  username,
  text,
  level
}) => {
  return <Group>
      <Box p={8}>
        <Paper pos="relative" radius="sm" className={classes.message}>
          <Image src="/assets/aside/frchat.svg" pos="absolute" w={12} bottom={0} left={-10} alt="decor" />
          <Badge radius="md" c="dark" px="md" className={classes.lv} pos="absolute" right={0} display={isLevel ? '' : 'none'}>
            {level}
          </Badge>
          <Stack p={12} gap={4}>
            <Group gap={4} display={isAvatar ? '' : 'none'}>
              <Avatar src="/assets/aside/avatar.svg" size={20} />
              <Text fz="xs" fw={500} c="var(--text-prime)">
                {username}
              </Text>
            </Group>

            <Text fz="xs" fw={500}>
              <Text span inherit c="prime.12" display={isTag ? '' : 'none'}>
                {tag}
              </Text>
              <Text span inherit c="var(--text-white)" ml={4}>
                {text}
              </Text>
            </Text>
          </Stack>
        </Paper>
      </Box>
    </Group>;
};